import useSWR from "swr"

import { InfraCmtResponse } from "~/@shared/api-types/InfraCmtResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

const PATH = "/student/todo-status"

type GetStudentTodoStatus = InfraCmtResponse<{
  show_input_flow: boolean
  show_confirm_year: boolean
}>

/** @see https://github.com/Traimmu/Infra/pull/4501 */
export const fetchGetStudentTodoStatus = defineFetcher((): Promise<GetStudentTodoStatus> => {
  return GET(PATH)
})

export const useSWRForFetchGetStudentTodoStatus = () => useSWR(PATH, fetchGetStudentTodoStatus)
